import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "text-danger" }
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "text-danger" }
const _hoisted_14 = { class: "col-lg-6" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "text-danger" }
const _hoisted_18 = { class: "col-lg-6" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "text-danger" }

import { useField, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { onMounted, ref } from "vue";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { mapOptionMultiselect } from "@/utils/helper";
import { usePositionStore } from "@/stores/master/position";
import { CascadingSchemePayload } from "@/types/interface/cascading-scheme";
import { useCascadingSchemeStore } from "@/stores/management/cascading-scheme";
import { useCategoryGroupStore } from "@/stores/master/category-group-store";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateCascadingScheme',
  setup(__props) {

const idCascadingScheme = ref<string>("");
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const groupCategoryStore = useCategoryGroupStore();
const positionStore = usePositionStore();
const cascadingSchemeStore = useCascadingSchemeStore();

const listPosition = ref<any>();
const listGroupCategory = ref<any>();
const detailCascadingScheme = ref<any>();

const validationSchema = toTypedSchema(
  zod.object({
    group_category: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.number()
    ),
    submission: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.number()
    ),
    approval: zod.preprocess(
      (val) => (val && typeof val === "object" ? val.value : val),
      zod.number()
    ),
    step: zod.number(),
  })
);

const { handleSubmit, errors } = useForm({
  validationSchema,
});

const { value: group_category } = useField<number>("group_category");
const { value: submission } = useField<number>("submission");
const { value: approval } = useField<number>("approval");
const { value: step } = useField<number>("step");

const onSubmit = handleSubmit(async (values) => {
  isLoading.value = true;
  const payloadCascadingScheme: CascadingSchemePayload = {
    group_category_id: group_category.value?.value,
    submission: submission.value?.value,
    approval: approval.value?.value,
    step_number: step.value,
  };

  const responseApi = ref<any>();
  if (isEdit.value == true) {
    responseApi.value = await cascadingSchemeStore.dispatchUpdate(
      idCascadingScheme.value,
      payloadCascadingScheme
    );
  } else {
    responseApi.value = await cascadingSchemeStore.dispatchCreate(
      payloadCascadingScheme
    );
  }
  const { success, message } = responseApi.value;
  if (success == true) {
    setTimeout(() => {
      isLoading.value = false;
      toast.success(
        isEdit.value
          ? "Cascading Scheme Successfully Updated"
          : "Cascading Scheme Successfully Added"
      );
      router.push("/management/cascading-scheme");
    }, 1000);
  } else {
    isLoading.value = false;
    toast.error(message);
  }
});

const loadListPosition = async () => {
  const { success, message } = await positionStore.dispatchGetPositions();
  if (success) {
    listPosition.value = mapOptionMultiselect(
      await positionStore?.positions?.items
    );
  }
};

const loadListGroupCategory = async () => {
  const { success, message } =
    await groupCategoryStore.dispatchGetCategoryGroups();
  if (success) {
    listGroupCategory.value = mapOptionMultiselect(
      await groupCategoryStore.categoryGroups.items
    );
  }
};

const loadDetailCascadingScheme = async () => {
  const { success, message } = await cascadingSchemeStore.dispatchDetail(
    idCascadingScheme.value
  );
  if (success) {
    detailCascadingScheme.value = cascadingSchemeStore.scheme?.data;
    group_category.value = mapOptionMultiselect(
      detailCascadingScheme.value?.groupCategory
    );
    submission.value = mapOptionMultiselect(
      detailCascadingScheme.value?.submission
    );
    approval.value = mapOptionMultiselect(
      detailCascadingScheme.value?.approval
    );
  }
};

onMounted(() => {
  loadListPosition();
  loadListGroupCategory();
  if (router.currentRoute.value.params.id != undefined) {
    isEdit.value = true;
    idCascadingScheme.value = router.currentRoute.value.params.id.toString();
    loadDetailCascadingScheme();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
            _createElementVNode("h3", { class: "mb-0" }, "Form Create Cascading Scheme"),
            _createElementVNode("a", {
              class: "btn btn-danger fw-semibold text-white px-3",
              type: "button",
              href: "/management/cascading-scheme"
            }, [
              _createElementVNode("i", { class: "ri-arrow-drop-left-line text-gray-light" }),
              _createTextVNode(" Back To List Cascading Scheme ")
            ])
          ], -1)),
          (isLoading.value)
            ? (_openBlock(), _createBlock(BaseLoading, {
                key: 0,
                text: "Processing Data..."
              }))
            : _createCommentVNode("", true),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                onSubmit: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
                class: "row g-3 needs-validation form"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[5] || (_cache[5] = _createElementVNode("label", {
                        for: "group_category",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Group Category Store Name "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_unref(vSelect), {
                          modelValue: _unref(group_category),
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(group_category) ? (group_category).value = $event : null)),
                          options: listGroupCategory.value,
                          placeholder: "Choose Group Category"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(errors).group_category), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[6] || (_cache[6] = _createElementVNode("label", {
                        for: "submission",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Submission Rank "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_unref(vSelect), {
                          modelValue: _unref(submission),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(submission) ? (submission).value = $event : null)),
                          options: listPosition.value,
                          placeholder: "Choose Submission Rank"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(errors).submission), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[7] || (_cache[7] = _createElementVNode("label", {
                        for: "approval",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Approval Rank "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_unref(vSelect), {
                          modelValue: _unref(approval),
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(approval) ? (approval).value = $event : null)),
                          options: listPosition.value,
                          placeholder: "Choose Approval Rank"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(errors).approval), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _cache[8] || (_cache[8] = _createElementVNode("label", {
                        for: "step",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Step Number / Level "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_20, [
                        _withDirectives(_createElementVNode("input", {
                          name: "step",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(step) ? (step).value = $event : null)),
                          placeholder: "Step Nummber / Level",
                          type: "number",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(step)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(errors).step), 1)
                    ])
                  ]),
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-12 mt-5" }, [
                    _createElementVNode("button", {
                      class: "btn btn-primary fw-semibold text-white py-2 px-3",
                      type: "submit"
                    }, " Save ")
                  ], -1))
                ])
              ], 32))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})